module.exports = __webpack_public_path__ + "img/summary-applications-count.31e29925.svg";